import kit from "../../plugins/kit.js"
import {
    openWindowWithPost,
    getStocks,
    readyQueryParam,
} from "./StockService.js"
import XLSX from "xlsx";
import i18nKit from "../../plugins/I18N.js"
import { Message  } from "element-ui";

let api = kit.api;
let i18n = i18nKit.methods;

/**
 * 导出建单资料
 * @param {*} options 
 * @param {*} query 
 * @param {*} originCols 
 * @param {*} isStore 
 */
const exportJiandan = (options, query, originCols, isStore) => {
    //options.columns[0].property  字段的key
    //options.columns[0].property  字段的显示名字
    //options.filename 导出的文件名
    //options.mode  导出模式："current"/"selected" / all 
    //options.type 导出类型："xlsx"          
    
    //获取要导出字段。
    //query.queries[0].colName

    let params =  readyQueryParam(false, query, originCols, isStore);

    // console.log('aa',params)
    // console.log('bb',this.query)
    // console.log('cc',options)

    let cols = [];

    //过滤字段，没选中的字段，就不导出
    params.columns.forEach(col => {
        let exist = options.columns.find(c => c.property == col.colName || c.property == col.fieldName);
        if(exist){
            cols.push(Object.assign({label: exist.title}, col))
        }
    });
    
    // console.log('dd',params)
    //如果模式selected，则将id传入到数据库
    let mode = options.mode;

    if(mode == 'all'){
        params.length =50000;
        params.start = 0;
    }else{
        let ids = options.data.map(d => d.id);
        params.length = ids.length;
        params.start = 0;
        params["ids"] = ids;
    }
    
    params.columns = cols;

    // console.log('dd',params)
    //构建请求url
    let exportUrl =  api.export.exportStockList;

    console.log(params);
    openWindowWithPost(exportUrl, {
        query: JSON.stringify(params),
        mode: options.mode,
        type: options.type,
        isExportCurrPage: 0,
        filename: encodeURIComponent(options.filename)
    })
}

/**
 * 下载excel
 * @param {} data 数据 [[],[]]
 * @param {*} filename 文件名
 */
const doDownloadXlsx = (data, filename) => {
    //下载excel
    const { writeFile, utils } = XLSX;

    let wb = utils.book_new()
    let worksheet = utils.aoa_to_sheet(data);
    utils.book_append_sheet(wb, worksheet, "Sheet1");
    writeFile(wb, filename+".xlsx");
    Message(i18n.msg('导出成功'));
}

/**
 * 构建表头
 * @param {*} options 
 * @returns 
 */
const buildTitles = (options) => {
    let columns = options.columns;
    //构建表头
    let titles = [];
    for(let i = 0; i<columns.length; i++){
        let columnInfo = columns[i];
        if(columnInfo.type !== "checkbox"){
            titles.push(columnInfo.title);
        }
    }
    return titles;
}

/**
 * 获取指定cell的值
 * @param {*} tableRow 每一行的的数据
 * @param {*} columnInfo 指定列的信息
 * @returns 
 */
const getCellValue = (tableRow, columnInfo) => {

    let value = tableRow[columnInfo.property];  //获取字段值
    let formatter = columnInfo.formatter;  //获取字段格式化函数
    if(formatter){ //如果字段格式化函数存在，则调用
        value = formatter({
            cellValue: value, 
            row: tableRow, 
            column: columnInfo
        });
    }

    if(value === undefined){
        value = "";
    }

    if(value === null){
        value = "";
    }

    if(value === 'null'){
        value = "";
    }

    return value;
}

/**
 * 导出当前页面数据
 * @param options: vxetable导出的参数
 */
const exportPage = (options) => {

    //获取待导出数据
    let tableData = options.data;
    let columns = options.columns;

    //构建导出数据
    let data = []; 
    tableData.forEach(tableRow => {
        let row = [];
        for(let i = 0; i<columns.length; i++){  
            let columnInfo = columns[i];  //获取字段信息
            if(columnInfo.type === "checkbox"){
                continue;
            }
            row.push(getCellValue(tableRow, columnInfo) );
        }

        data.push(row);
    });
    
    let titles = buildTitles(options);
    doDownloadXlsx([titles, ...data], options.filename)
    
}

/**
 * 从后台下载所有数据导出
 * @param {*} options 
 * @param {*} query 
 * @param {*} originCols 
 * @param {*} isStore 
 */
const exportAll = (options, query, originCols, isStore)=>{

    //从后台请求数据
    let params =  readyQueryParam(false, query, originCols, isStore);
    let getStockDatas = async () => {
        params.length = 50000;
        params.start = 0;
        let tableData =  await getStocks(params, query.history);

        let columns = options.columns;

        //构建导出数据
        let data = []; 
        tableData.forEach(tableRow => {
            let row = [];
            for(let i = 0; i<columns.length; i++){  
                let columnInfo = columns[i];  //获取字段信息
                if(columnInfo.type === "checkbox"){
                    continue;
                }
                row.push(getCellValue(tableRow, columnInfo));
            }
            data.push(row);
        });
    
        let titles = buildTitles(options);
        doDownloadXlsx([titles, ...data], options.filename)
    }
    getStockDatas();
}

/**
 * 导出页面数据
 * @param  type string 导出类型：a: 导出列表数据，f: 导出建单资料
 * @param options: vxetable导出的参数
 * @param query 要导出所有的时候通过query去后台获取所有的数据
 */
export function exportStocks(type, options, query, originCols, isStore){
    //current, selected, all
    let mode = options.mode;

    //导出建单资料
    if(type == 'f'){
        exportJiandan(options, query, originCols, isStore);
    }else if(type == 'a'){ //导出列表
        if(mode == 'all'){ //导出所有，需要去后台导出
            //从后台请求数据
            exportAll(options, query, originCols, isStore);

        }else {  //导出选中和导出当前页，在前台导出
            exportPage(options);
        }
    }
}


